import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/AboutSection.module.css";
import { useNavigate } from "react-router-dom";
import hero from "../assets/hero.jpg";

export default function AboutSection() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run once (important for performance)
        }
      },
      {
        threshold: 0.25, // triggers when 25% visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`${styles.section} ${isVisible ? styles.active : ""}`}
      id="about"
    >
      <div className={styles.container}>

        <div className={styles.left}>
          <img
            src={hero}
            alt="Fegaropetra Seaview"
          />

          <div className={styles.badge}>
            <h4>Authentic Taste</h4>
            <p>Fresh Mediterranean ingredients</p>
          </div>
        </div>

        <div className={styles.right}>
          <span>About Fegaropetra</span>

          <h2>A Mediterranean Experience Beyond Dining</h2>

          <p>
            Fegaropetra is a family-owned restaurant located in the beautiful bay of
            Garitsa, offering stunning views of the sea and Corfu's Old Fortress.
          </p>

          <p>
            With a warm atmosphere, fresh Greek ingredients, and traditional seafood
            recipes prepared with care by our chef, every meal celebrates authentic
            Greek hospitality and Mediterranean flavor.
          </p>

          <div className={styles.actions}>
            <button onClick={() => navigate('/reservation')}>
              Reserve Your Table →
            </button>

            <a
              href="/about"
            >
              Learn More
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}